var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconObject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {fill:#050505;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,5.3l-7.1-4.1c-0.9-0.5-2-0.5-3,0L3.5,5.3C2.5,5.9,2,6.9,2,7.9v8.2c0,1,0.6,2,1.5,2.6l7.1,4.1 c0.4,0.3,1,0.4,1.5,0.4s1-0.1,1.5-0.4l7.1-4.1c0.9-0.5,1.5-1.5,1.5-2.6V7.9C22,6.9,21.5,5.9,20.5,5.3z M11.5,3 c0.1-0.1,0.3-0.1,0.5-0.1s0.3,0,0.5,0.1L19,6.8l-7,4.1L5,6.8L11.5,3z M4.5,16.9C4.2,16.7,4,16.4,4,16.1V8.5l7,4v8.1L4.5,16.9z  M20,16.1c0,0.3-0.2,0.7-0.5,0.8L13,20.7v-8.1l7-4V16.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObject);
export default __webpack_public_path__ + "static/media/icon-object.d61739b0da89881e67c2e03748fe4060.svg";
export { ForwardRef as ReactComponent };